import { resolvePath } from "@utils/resolvePath";

interface DownloadAndOpenPdfArgs {
  pdfPath: string; // Path relative to public folder, e.g., "/pdf/irdaiguideline.pdf"
  fileName?: string; // Optional custom filename for download
}

/**
 * Action to download and open a PDF from local PDF store in a new tab
 * @param args - Configuration object
 * @param args.pdfPath - The path to the PDF file relative to public folder (required)
 * @param args.fileName - Optional custom filename for download (defaults to PDF filename)
 */
export const DownloadAndOpenPdf = (args: DownloadAndOpenPdfArgs) => {
  const { pdfPath, fileName } = args || {};

  if (!pdfPath) {
    console.error("DownloadAndOpenPdf: pdfPath is required");
    return;
  }

  if (typeof window === "undefined") {
    console.error(
      "DownloadAndOpenPdf: This action can only be executed in the browser"
    );
    return;
  }

  // Resolve the full path using the resolvePath utility
  const resolvedPath = resolvePath(pdfPath);

  // Extract filename from path if not provided
  const downloadFileName =
    fileName || pdfPath.split("/").pop() || "document.pdf";

  // Create a temporary anchor element for download
  const link = document.createElement("a");
  link.href = resolvedPath;
  link.download = downloadFileName;
  link.target = "_blank";
  link.rel = "noopener noreferrer";

  // Append to body, click, and remove
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Open PDF in new tab
  window.open(resolvedPath, "_blank", "noopener,noreferrer");
};

export default DownloadAndOpenPdf;
